import { createContext } from 'react';

const ApiContext = createContext({ status: 'IDLE' });

export default ApiContext;
